module.exports = __webpack_public_path__ + "img/logo.ce84b327.svg";